import { render, staticRenderFns } from "./EmpAdv_copy.vue?vue&type=template&id=095fe53a&scoped=true&"
import script from "./EmpAdv_copy.vue?vue&type=script&lang=js&"
export * from "./EmpAdv_copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095fe53a",
  null
  
)

export default component.exports